/* eslint-disable jsx-a11y/click-events-have-key-events */
import { VehicleFuelType } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import { ElectricIcon, FuelIcon } from "@/shared/icons";

type VehicleSpawnCardProps = {
  name: string;
  plateNumber: string;
  fuelType: VehicleFuelType;
  image: string;
  isActive?: boolean;
  onClick?: () => void;
};

function FuelTypeLabel({ fuelType }: { fuelType: VehicleFuelType }) {
  let Icon = null;

  switch (fuelType) {
    case VehicleFuelType.Electric:
      Icon = ElectricIcon;
      break;

    default:
      Icon = FuelIcon;
  }

  return (
    <div className="flex gap-1.5 items-center font-bold self-end">
      <Icon size={16} /> {fuelType}
    </div>
  );
}

export function VehicleSpawnCard({
  name,
  plateNumber,
  fuelType,
  image,
  isActive = false,
  onClick,
}: VehicleSpawnCardProps) {
  const { t } = useTranslation("vehicle");

  return (
    <div
      role="button"
      tabIndex={0}
      className={cn(
        "relative group",
        "w-[220px] h-[220px] bg-dark-800 rounded-2xl p-[20px] flex flex-col justify-between",
        isActive && "bg-[linear-gradient(116.49deg,rgba(215,52,52,0.3)_0%,rgba(24,24,24,0)_65%)]",
      )}
      onClick={onClick}
    >
      <div
        className={cn(
          "absolute z-0 inset-0",
          "rounded-2xl bg-[linear-gradient(116.49deg,rgba(215,52,52,0.3)_0%,rgba(24,24,24,0)_65%)]",
          "opacity-0 group-hover:opacity-100 transition-opacity duration-[350ms] hover:duration-0",
        )}
      />

      <div className="z-1 text-white font-16 font-semibold">{name}</div>

      <img src={image} alt={name} className="z-1 w-full h-[110px] object-contain" />

      <div className="flex justify-between flex-end text-[15px]">
        <div className="flex gap-1.5 items-center font-bold leading-none">
          <FuelTypeLabel fuelType={fuelType} />
        </div>

        <div className="flex flex-col leading-none">
          <div className="font-bold text-[#ff4e4e] text-right">{plateNumber}</div>
          <div className="font-semibold text-[#ffffff80] text-right">{t("vehicleInfo.number")}</div>
        </div>
      </div>
    </div>
  );
}
